import React, { useState } from 'react';
import { Outlet as ChildrenRoutes } from 'react-router-dom';

import { PageSection } from '@amzn/imdb-shared-meridian-components/components/PageSection';
import { ResetCssStyles } from '@amzn/imdb-shared-meridian-components/components/ResetCssStyles';
import Alert from '@amzn/meridian/alert';
import AppLayout from '@amzn/meridian/app-layout';
import Theme from '@amzn/meridian/theme';
import Toaster from '@amzn/meridian/toaster';
import { ToasterToasts } from '@amzn/meridian/toaster/toaster';

import customTheme from '../../assets/theme.json';
import { useGlobalContext } from '../../context/useGlobalContext';
import { Header } from './Header/Header';
import { SideBar } from './SideBar/SideBar';

let incrementingId = 0;
const toastVisibilityTimeout = 10000; // 10 seconds in milliseconds

export const Layout: React.FC = () => {
    const context = useGlobalContext();
    const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(true);

    const [toasts, setToasts] = useState<ToasterToasts[]>([]);
    const onCloseToast = (id) => setToasts(toasts.filter((t) => t.id !== id));
    const onOpenToast = () => setToasts(toasts.concat({ id: `${++incrementingId}`, timeout: toastVisibilityTimeout }));

    return (
        <Theme palette={customTheme} mode={'auto'}>
            <>
                <ResetCssStyles />
                <AppLayout headerComponent={Header} sidebarComponent={SideBar} backgroundColor={customTheme.palette50}>
                    <Toaster toasts={toasts} onCloseToast={onCloseToast}>
                        {(toast) => (
                            <Alert toast={true} onClose={toast.onClose}>
                                Not a valid customerId or ListId. Did you enter a userId by mistake?
                            </Alert>
                        )}
                    </Toaster>
                    <Header
                        isSideBarOpen={isSideBarOpen}
                        setIsSideBarOpen={setIsSideBarOpen}
                        onOpenToast={onOpenToast}
                    />
                    <SideBar isSideBarOpen={isSideBarOpen} />
                    <PageSection>
                        <ChildrenRoutes context={context} />
                    </PageSection>
                </AppLayout>
            </>
        </Theme>
    );
};
